import DateEventDataSchema from '@lts-web/schemas/DateEventDataSchema';
import { readOnlyProperty } from '@lts-web/utils/ObjectUtil';

class DateEventData {
    constructor (data) {
        this._data = Object.freeze(DateEventDataSchema(data));
        readOnlyProperty(this, '_data');
    }

    getCode () {
        return this._data.code;
    }

    getName () {
        return this._data.name;
    }

    getText () {
        return this._data.text;
    }

    isStatic () {
        return this._data.isStatic;
    }

    isActive () {
        return this._data.isActive;
    }
    getSubNames (){
        return this._data.getSubNames;
    }
}

export default DateEventData;